/* assets/trending-products.js */

(function () {
  let isAjaxLoading = false;
  let infiniteObserver = null;

  // Initialize all dynamic events inside the trending products section
  function initTrendingSection() {
    const container = document.querySelector('.trending-products-container');
    if (!container) return;

    const sectionId = container.dataset.sectionId;

    // 1. Accordion Toggles for Filter Groups
    const headers = document.querySelectorAll(`#modal-filters-${sectionId} .trending-products__filter-group-header`);
    headers.forEach(header => {
      // Avoid duplicate binding
      if (header.dataset.bound) return;
      header.dataset.bound = 'true';

      header.addEventListener('click', function () {
        const group = this.closest('.trending-products__filter-group');
        group.classList.toggle('is-expanded');
      });
    });

    // 2. Load More Button Click
    const loadMoreBtn = container.querySelector('.trending-products__load-more');
    if (loadMoreBtn && !loadMoreBtn.dataset.bound) {
      loadMoreBtn.dataset.bound = 'true';
      loadMoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        loadNextPage(this);
      });
    }

    // 3. Infinite Scroll Sentinel Intersection Observer
    const sentinel = container.querySelector('.trending-products__infinite-scroll-sentinel');
    if (sentinel) {
      if (infiniteObserver) {
        infiniteObserver.disconnect();
      }

      infiniteObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !isAjaxLoading) {
            loadNextPage(sentinel);
          }
        });
      }, {
        rootMargin: '200px'
      });

      infiniteObserver.observe(sentinel);
    }

    // 4. Reset Filters Buttons
    const resetFiltersBtn = document.querySelector(`#modal-filters-${sectionId} .trending-products__modal-clear-filters`);
    if (resetFiltersBtn && !resetFiltersBtn.dataset.bound) {
      resetFiltersBtn.dataset.bound = 'true';
      resetFiltersBtn.addEventListener('click', function () {
        closeAllModals();
        fetchProductsHTML(this.dataset.clearUrl);
      });
    }

    // 5. Active Badge Removes
    const activeBadges = container.querySelectorAll('.trending-products__active-filter-badge');
    activeBadges.forEach(badge => {
      if (badge.dataset.bound) return;
      badge.dataset.bound = 'true';
      badge.addEventListener('click', function () {
        fetchProductsHTML(this.dataset.filterRemoveUrl);
      });
    });

    // 6. Clear All Link
    const clearAllLink = container.querySelector('.trending-products__clear-all-link');
    if (clearAllLink && !clearAllLink.dataset.bound) {
      clearAllLink.dataset.bound = 'true';
      clearAllLink.addEventListener('click', function () {
        fetchProductsHTML(this.dataset.clearUrl);
      });
    }

    // 7. Reset Sort Button
    const resetSortBtn = document.querySelector(`#modal-sort-${sectionId} .trending-products__modal-reset-sort`);
    if (resetSortBtn && !resetSortBtn.dataset.bound) {
      resetSortBtn.dataset.bound = 'true';
      resetSortBtn.addEventListener('click', function () {
        const defaultSort = this.dataset.defaultSort;
        const activeUrl = new URL(window.location.href);
        activeUrl.searchParams.set('sort_by', defaultSort);
        closeAllModals();
        fetchProductsHTML(activeUrl.toString());
      });
    }

    // 8. Category Selector Switch
    const categoryItems = document.querySelectorAll(`#modal-categories-${sectionId} .trending-products__category-item`);
    categoryItems.forEach(item => {
      if (item.dataset.bound) return;
      item.dataset.bound = 'true';
      item.addEventListener('click', function () {
        closeAllModals();
        fetchProductsHTML(this.dataset.collectionUrl);
      });
    });

    // 9. Reset Category Choice
    const resetCategoryBtn = document.querySelector(`#modal-categories-${sectionId} .trending-products__modal-reset-category`);
    if (resetCategoryBtn && !resetCategoryBtn.dataset.bound) {
      resetCategoryBtn.dataset.bound = 'true';
      resetCategoryBtn.addEventListener('click', function () {
        closeAllModals();
        // Reset to first collection item configured
        const firstCategoryItem = document.querySelector(`#modal-categories-${sectionId} .trending-products__category-item`);
        if (firstCategoryItem) {
          fetchProductsHTML(firstCategoryItem.dataset.collectionUrl);
        }
      });
    }

    // 10. Age Timeline Filter Dropdown inside trending section
    const filterBtn = container.querySelector('#TrendingFilterBtn-' + sectionId);
    const wrapper = container.querySelector('#TrendingDropdownWrapper-' + sectionId);
    const filterItems = container.querySelectorAll('#TrendingDropdownList-' + sectionId + ' .trending-products__dropdown-item');
    const labelEl = container.querySelector('#TrendingFilterLabel-' + sectionId);

    if (filterBtn && wrapper) {
      if (!filterBtn.dataset.filterBound) {
        filterBtn.dataset.filterBound = 'true';
        filterBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          wrapper.classList.toggle('is-open');
        });
        
        // Close when clicking outside
        document.addEventListener('click', (e) => {
          if (!wrapper.contains(e.target)) {
            wrapper.classList.remove('is-open');
          }
        });
      }
    }

    if (filterItems && filterItems.length > 0) {
      filterItems.forEach(item => {
        if (item.dataset.filterBound) return;
        item.dataset.filterBound = 'true';
        item.addEventListener('click', function () {
          // Remove active state from other items
          filterItems.forEach(i => i.classList.remove('is-active'));
          this.classList.add('is-active');
          
          // Update label
          if (labelEl) {
            labelEl.textContent = this.textContent;
          }
          
          applyTimelineFilter(container, sectionId);
          
          // Close dropdown
          if (wrapper) {
            wrapper.classList.remove('is-open');
          }
        });
      });
      
      // Sync UI state dynamically on load and re-initialization
      applyTimelineFilter(container, sectionId);
    }

    // 11. Inline Dropdowns Toggle
    const inlineToggleBtns = container.querySelectorAll('[data-inline-toggle]');
    inlineToggleBtns.forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const dropdown = this.closest('.trending-products__inline-dropdown');
        const isOpen = dropdown.classList.contains('is-open');
        
        // Close all other inline dropdowns first
        container.querySelectorAll('.trending-products__inline-dropdown').forEach(d => {
          d.classList.remove('is-open');
        });
        
        if (!isOpen) {
          dropdown.classList.add('is-open');
        }
      });
    });

    // Close inline dropdowns when clicking outside
    if (!document.datasetInlineBound) {
      document.datasetInlineBound = 'true';
      document.addEventListener('click', function (e) {
        const openDropdown = document.querySelector('.trending-products__inline-dropdown.is-open');
        if (openDropdown && !openDropdown.contains(e.target)) {
          openDropdown.classList.remove('is-open');
        }
      });
    }

    // Auto apply checkboxes inside inline dropdowns
    const inlineCheckboxes = container.querySelectorAll('input[data-inline-filter-auto]');
    inlineCheckboxes.forEach(cb => {
      if (cb.dataset.bound) return;
      cb.dataset.bound = 'true';
      cb.addEventListener('change', function () {
        applyInlineFilters(container);
      });
    });

    // Price range apply button click
    const inlinePriceApplyBtns = container.querySelectorAll('[data-inline-price-apply]');
    inlinePriceApplyBtns.forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function () {
        const dropdown = this.closest('.trending-products__inline-dropdown');
        if (dropdown) dropdown.classList.remove('is-open');
        applyInlineFilters(container);
      });
    });

    // Inline sorting click
    const inlineSortOptions = container.querySelectorAll('.trending-products__inline-sort-option');
    inlineSortOptions.forEach(opt => {
      if (opt.dataset.bound) return;
      opt.dataset.bound = 'true';
      opt.addEventListener('click', function () {
        const value = this.dataset.sortValue;
        const activeUrl = new URL(window.location.href);
        activeUrl.searchParams.set('sort_by', value);
        
        // Close dropdown
        const dropdown = this.closest('.trending-products__inline-dropdown');
        if (dropdown) dropdown.classList.remove('is-open');
        
        // Get active category collection URL
        const activeCategory = document.querySelector('.trending-products__category-item.is-active');
        const baseUrl = activeCategory ? activeCategory.dataset.collectionUrl : container.dataset.collectionUrl;
        const targetUrl = new URL(baseUrl, window.location.origin);
        
        // Copy existing filters from inline bar to new url search params
        const inlineBar = container.querySelector('.trending-products__inline-bar');
        if (inlineBar) {
          const checkboxes = inlineBar.querySelectorAll('input[type="checkbox"]:checked');
          checkboxes.forEach(cb => {
            targetUrl.searchParams.append(cb.name, cb.value);
          });
          const priceInputs = inlineBar.querySelectorAll('input[data-inline-price-filter]');
          priceInputs.forEach(input => {
            if (input.value) {
              targetUrl.searchParams.append(input.name, input.value);
            }
          });
        }
        
        targetUrl.searchParams.set('sort_by', value);
        fetchProductsHTML(targetUrl.toString());
      });
    });

    // 12. Mobile radio sort option selection change
    const sortRadios = document.querySelectorAll(`#modal-filters-${sectionId} input[name="modal_sort_by"]`);
    sortRadios.forEach(radio => {
      if (radio.dataset.bound) return;
      radio.dataset.bound = 'true';
      radio.addEventListener('change', function () {
        const label = this.closest('label').querySelector('.trending-products__filter-checkbox-text').textContent.trim();
        const activeLabelEl = document.getElementById(`TrendingSortActiveLabel-${sectionId}`);
        if (activeLabelEl) {
          activeLabelEl.textContent = label;
        }
      });
    });

    // 13. Mobile Sticky Bottom Bar Scroll and Layout bindings
    initMobileStickyBar(container, sectionId);
  }

  // Helper function to filter products by dynamic timeline
  function applyTimelineFilter(container, sectionId) {
    const activeItem = container.querySelector('#TrendingDropdownList-' + sectionId + ' .trending-products__dropdown-item.is-active');
    if (!activeItem) return;

    const maxDays = parseInt(activeItem.dataset.filterDays, 10);
    const liveGridItems = container.querySelectorAll('.trending-products__grid-item');
    const countEl = container.querySelector('#TrendingProductsCount-' + sectionId);
    const emptyEl = container.querySelector('#TrendingProductsEmpty-' + sectionId);
    let visibleCount = 0;

    liveGridItems.forEach(card => {
      const cardAge = parseInt(card.dataset.ageDays, 10) || 0;
      if (cardAge <= maxDays) {
        card.classList.remove('is-hidden');
        visibleCount++;
      } else {
        card.classList.add('is-hidden');
      }
    });

    if (countEl) {
      countEl.textContent = visibleCount + ' Items';
    }

    if (emptyEl) {
      if (visibleCount === 0) {
        emptyEl.classList.remove('is-hidden');
      } else {
        emptyEl.classList.add('is-hidden');
      }
    }
  }

  // Fetch the next pagination page and append its cards to the grid
  function loadNextPage(triggerElement) {
    const nextUrl = triggerElement.dataset.nextUrl;
    if (!nextUrl || isAjaxLoading) return;

    isAjaxLoading = true;
    const grid = document.querySelector('.trending-products__grid');
    const paginationContainer = document.querySelector('.trending-products__pagination-container');

    // Create a temporary loader indicator
    const tempLoader = document.createElement('div');
    tempLoader.className = 'trending-products__pagination-container';
    tempLoader.innerHTML = '<div class="trending-products__spinner"></div>';
    if (paginationContainer) {
      paginationContainer.replaceWith(tempLoader);
    }

    const sectionId = document.querySelector('.trending-products-container').dataset.sectionId;
    const fetchUrl = new URL(nextUrl, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);
    
    // Preserve preview / customizer tokens
    const currentParams = new URLSearchParams(window.location.search);
    for (const [key, value] of currentParams.entries()) {
      if (key !== 'section_id') {
        fetchUrl.searchParams.set(key, value);
      }
    }

    fetch(fetchUrl.toString())
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Extract new cards
        const newCards = doc.querySelectorAll('.trending-products__grid-item');
        newCards.forEach(card => {
          grid.appendChild(card);
        });

        // Extract new pagination/sentinel
        const newPagination = doc.querySelector('.trending-products__pagination-container');
        if (tempLoader) {
          if (newPagination) {
            tempLoader.replaceWith(newPagination);
          } else {
            tempLoader.remove();
          }
        }

        isAjaxLoading = false;
        // Re-initialize observer and event triggers for newly loaded DOM nodes
        initTrendingSection();
      })
      .catch(error => {
        console.error('Error fetching load-more products:', error);
        isAjaxLoading = false;
        if (tempLoader) tempLoader.remove();
      });
  }

  // Central AJAX routine to query and update products, filters, sorting options, and badge attributes
  function fetchProductsHTML(url) {
    if (isAjaxLoading) return;
    isAjaxLoading = true;

    const container = document.querySelector('.trending-products-container');
    const ajaxArea = document.getElementById(`TrendingAjaxContainer-${container.dataset.sectionId}`);
    if (ajaxArea) {
      ajaxArea.classList.add('is-loading');
    }

    const sectionId = container.dataset.sectionId;
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    // Preserve preview / customizer tokens
    const currentParams = new URLSearchParams(window.location.search);
    for (const [key, value] of currentParams.entries()) {
      if (key !== 'section_id') {
        fetchUrl.searchParams.set(key, value);
      }
    }

    fetch(fetchUrl.toString())
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // 1. Swap main products area
        const newAjaxArea = doc.getElementById(`TrendingAjaxContainer-${sectionId}`);
        const oldAjaxArea = document.getElementById(`TrendingAjaxContainer-${sectionId}`);
        if (oldAjaxArea && newAjaxArea) {
          oldAjaxArea.replaceWith(newAjaxArea);
        }

        // 2. Update collection URL on section container
        const newContainer = doc.querySelector('.trending-products-container');
        if (newContainer && newContainer.dataset.collectionUrl) {
          container.dataset.collectionUrl = newContainer.dataset.collectionUrl;
        }

        // 3. Update category button labels (mobile sticky bar & desktop inline pill)
        const oldStickyText = document.getElementById(`TrendingStickyCategoryText-${sectionId}`);
        const newStickyText = doc.getElementById(`TrendingStickyCategoryText-${sectionId}`);
        if (oldStickyText && newStickyText) {
          oldStickyText.textContent = newStickyText.textContent;
        }

        const oldInlineText = document.getElementById(`TrendingInlineCategoryText-${sectionId}`);
        const newInlineText = doc.getElementById(`TrendingInlineCategoryText-${sectionId}`);
        if (oldInlineText && newInlineText) {
          oldInlineText.textContent = newInlineText.textContent;
        }

        // 4. Update count badges
        const oldProductsCount = document.getElementById(`TrendingProductsCount-${sectionId}`);
        const newProductsCount = doc.getElementById(`TrendingProductsCount-${sectionId}`);
        if (oldProductsCount && newProductsCount) {
          oldProductsCount.textContent = newProductsCount.textContent;
        }

        const oldModalCount = document.getElementById(`TrendingModalCount-${sectionId}`);
        const newModalCount = doc.getElementById(`TrendingModalCount-${sectionId}`);
        if (oldModalCount && newModalCount) {
          oldModalCount.textContent = newModalCount.textContent;
        }

        // Swap Inline Bar
        const oldInlineBar = container.querySelector('.trending-products__inline-bar');
        const newInlineBar = doc.querySelector('.trending-products__inline-bar');
        if (oldInlineBar && newInlineBar) {
          oldInlineBar.replaceWith(newInlineBar);
        }

        // 5. Swap Active Filters row
        const oldActiveFilters = container.querySelector('.trending-products__active-filters');
        const newActiveFilters = doc.querySelector('.trending-products__active-filters');
        if (oldActiveFilters) {
          if (newActiveFilters) {
            oldActiveFilters.replaceWith(newActiveFilters);
          } else {
            oldActiveFilters.remove();
          }
        } else if (newActiveFilters) {
          const topBar = container.querySelector('.trending-products__inline-bar');
          if (topBar) {
            topBar.insertAdjacentElement('afterend', newActiveFilters);
          }
        }

        // 6. Swap Modals Body to sync check states
        syncModalBody(`modal-categories-${sectionId}`, doc);
        syncModalBody(`modal-filters-${sectionId}`, doc);
        syncModalBody(`modal-sort-${sectionId}`, doc);

        // 7. Update browser history URL (so refresh retains selections)
        const cleanHistoryUrl = new URL(url, window.location.origin);
        cleanHistoryUrl.searchParams.delete('section_id');
        history.replaceState(null, '', cleanHistoryUrl.toString());

        isAjaxLoading = false;
        
        // Rebind buttons, observers, and listeners
        bindModalControls();
        initTrendingSection();
      })
      .catch(error => {
        console.error('Error filtering products:', error);
        isAjaxLoading = false;
        if (ajaxArea) {
          ajaxArea.classList.remove('is-loading');
        }
      });
  }

  // Helper function to serialize inline filters and trigger ajax call
  function applyInlineFilters(container) {
    const inlineBar = container.querySelector('.trending-products__inline-bar');
    if (!inlineBar) return;

    const params = new URLSearchParams();
    
    // Find all checked checkboxes inside the inline bar
    const checkboxes = inlineBar.querySelectorAll('input[type="checkbox"]:checked');
    checkboxes.forEach(cb => {
      params.append(cb.name, cb.value);
    });

    // Find all price range inputs that have values
    const priceInputs = inlineBar.querySelectorAll('input[data-inline-price-filter]');
    priceInputs.forEach(input => {
      if (input.value) {
        params.append(input.name, input.value);
      }
    });

    // Keep current sort_by if set in inline sort active option
    const activeSortOption = inlineBar.querySelector('.trending-products__inline-sort-option.is-active');
    if (activeSortOption) {
      params.set('sort_by', activeSortOption.dataset.sortValue);
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('sort_by')) {
        params.set('sort_by', urlParams.get('sort_by'));
      }
    }

    // Get the base collection url from active categories selection
    const activeCategory = document.querySelector('.trending-products__category-item.is-active');
    const baseUrl = activeCategory ? activeCategory.dataset.collectionUrl : container.dataset.collectionUrl;

    fetchProductsHTML(`${baseUrl}?${params.toString()}`);
  }

  // Replaces the modal body contents with the parsed version from the server to automatically synchronize check marks
  function syncModalBody(modalId, docSource) {
    const oldBody = document.querySelector(`#${modalId} .trending-products__modal-body`);
    const newBody = docSource.querySelector(`#${modalId} .trending-products__modal-body`);
    if (oldBody && newBody) {
      oldBody.replaceWith(newBody);
    }
  }

  // Handle modal openings, overlay transitions, scroll blocks, and clicks outside
  function bindModalControls() {
    const triggers = document.querySelectorAll('[data-modal-open]');
    triggers.forEach(trigger => {
      // Avoid duplicate triggers
      if (trigger.dataset.modalBound) return;
      trigger.dataset.modalBound = 'true';

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const modalId = this.dataset.modalOpen;
        const focusSort = this.hasAttribute('data-focus-sort') || this.classList.contains('trending-products__btn--sort');
        openModal(modalId, focusSort);
      });
    });

    const closers = document.querySelectorAll('[data-modal-close]');
    closers.forEach(closer => {
      if (closer.dataset.modalBound) return;
      closer.dataset.modalBound = 'true';

      closer.addEventListener('click', function (e) {
        e.preventDefault();
        closeAllModals();
      });
    });
  }

  function openModal(modalId, focusSort = false) {
    closeAllModals();
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden'; // block page scrolling
      
      // Auto expand sort group inside Filters Modal if focusSort is true
      if (modalId.includes('filters')) {
        modal.querySelectorAll('.trending-products__filter-group').forEach(g => g.classList.remove('is-expanded'));
        if (focusSort) {
          const sortGroup = modal.querySelector('.trending-products__filter-group[data-filter-index="sort-by"]');
          if (sortGroup) {
            sortGroup.classList.add('is-expanded');
          }
        }
      }
    }
  }

  function closeAllModals() {
    const modals = document.querySelectorAll('.trending-products__modal');
    modals.forEach(modal => {
      modal.classList.remove('is-open');
    });
    document.documentElement.style.overflow = ''; // restore scrolling
  }

  // Bind Submit actions for Filter and Sort Form submissions
  function bindFormSubmitListeners() {
    const body = document.body;

    // Delegate form submission from the Filters apply button
    body.addEventListener('click', function (e) {
      const applyFiltersBtn = e.target.closest('.trending-products__modal-apply-filters');
      if (applyFiltersBtn) {
        e.preventDefault();
        const container = document.querySelector('.trending-products-container');
        const form = document.getElementById(`FilterForm-${container.dataset.sectionId}`);
        if (form) {
          const formData = new FormData(form);
          
          // Get the selected sort option from modal radio buttons
          const activeRadio = form.querySelector('input[name="modal_sort_by"]:checked');
          if (activeRadio) {
            formData.set('sort_by', activeRadio.value);
          }
          
          const params = new URLSearchParams(formData);
          
          // Get the base collection url from active categories selection
          const activeCategory = document.querySelector('.trending-products__category-item.is-active');
          const baseUrl = activeCategory ? activeCategory.dataset.collectionUrl : container.dataset.collectionUrl;
          
          closeAllModals();
          fetchProductsHTML(`${baseUrl}?${params.toString()}`);
        }
      }
    });
  }  // Load filters asynchronously if we are on a non-collection page (like the homepage)
  function loadFiltersInitially() {
    const container = document.querySelector('.trending-products-container');
    if (!container) return;
    const sectionId = container.dataset.sectionId;
    const activeCategory = document.querySelector('.trending-products__category-item.is-active');
    const baseUrl = activeCategory ? activeCategory.dataset.collectionUrl : container.dataset.collectionUrl;
    
    // Check if the filter list is empty (ignore the Sort by group)
    const filterGroup = document.querySelector(`#modal-filters-${sectionId} .trending-products__filter-group:not([data-filter-index="sort-by"])`);
    if (!filterGroup && baseUrl) {
      const fetchUrl = new URL(baseUrl, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      
      // Preserve preview / customizer tokens
      const currentParams = new URLSearchParams(window.location.search);
      for (const [key, value] of currentParams.entries()) {
        if (key !== 'section_id') {
          fetchUrl.searchParams.set(key, value);
        }
      }

      fetch(fetchUrl.toString())
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Swap the filter modal content
          syncModalBody(`modal-filters-${sectionId}`, doc);
          
          // Swap the sort modal content
          syncModalBody(`modal-sort-${sectionId}`, doc);

          // Swap the inline filter bar content
          const oldInlineBar = container.querySelector('.trending-products__inline-bar');
          const newInlineBar = doc.querySelector('.trending-products__inline-bar');
          if (oldInlineBar && newInlineBar) {
            oldInlineBar.replaceWith(newInlineBar);
          }
          
          // Re-initialize event bindings
          bindModalControls();
          initTrendingSection();
        })
        .catch(err => console.error('Failed to load initial filters:', err));
    }
  }

  // Handle mobile sticky bottom bar scroll animation and layout updates
  function initMobileStickyBar(container, sectionId) {
    const stickyBar = document.getElementById(`TrendingMobileStickyBar-${sectionId}`);
    if (!stickyBar) return;

    // Grid layout switcher logic
    function applyGridPreference(cols) {
      const gridTarget = document.getElementById(`TrendingProductsGrid-${sectionId}`);
      localStorage.setItem('trending-mobile-grid-preference', cols);

      if (gridTarget) {
        gridTarget.classList.remove('mobile-grid-1', 'mobile-grid-2', 'mobile-grid-4');
        gridTarget.classList.add(`mobile-grid-${cols}`);
      }

      // Update button active state classes in sticky bar
      const toggleButtons = stickyBar.querySelectorAll('.grid-toggle-btn');
      toggleButtons.forEach(btn => {
        if (btn.dataset.grid === cols) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }

    const toggleButtons = stickyBar.querySelectorAll('.grid-toggle-btn');
    toggleButtons.forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const cols = this.dataset.grid;
        applyGridPreference(cols);
      });
    });

    // Apply saved grid column preference on load
    const initialPref = localStorage.getItem('trending-mobile-grid-preference') || '2';
    applyGridPreference(initialPref);

    // Scroll display logic (Show on scroll down inside container, Hide on scroll up or outside bounds)
    let lastScrollY = window.scrollY;
    const mobileNav = document.getElementById('mobile-sticky-nav');
    let ticking = false;
    
    // De-duplicate scroll handler
    if (window.trendingScrollHandler) {
      window.removeEventListener('scroll', window.trendingScrollHandler);
    }
    
    window.trendingScrollHandler = function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          const currentScrollY = window.scrollY;
          
          if (Math.abs(currentScrollY - lastScrollY) >= 10) {
            const rect = container.getBoundingClientRect();
            const isInsideSection = rect.top < window.innerHeight - 80 && rect.bottom > 80;
            
            if (isInsideSection && currentScrollY > 60) {
              if (currentScrollY > lastScrollY) {
                // Scrolling down -> Show trending sticky bar, Hide primary mobile sticky nav
                stickyBar.style.transform = 'translateY(0)';
                if (mobileNav) {
                  mobileNav.style.transform = 'translateY(100%)';
                }
              } else {
                // Scrolling up -> Hide trending sticky bar, Show primary mobile sticky nav
                stickyBar.style.transform = 'translateY(100%)';
                if (mobileNav) {
                  mobileNav.style.transform = 'translateY(0)';
                }
              }
            } else {
              // Outside section bounds -> Hide trending sticky bar
              stickyBar.style.transform = 'translateY(100%)';
            }
            
            lastScrollY = currentScrollY;
          }
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', window.trendingScrollHandler, { passive: true });
  }

  // Document Ready and Theme Editor event listeners
  document.addEventListener('DOMContentLoaded', () => {
    bindModalControls();
    initTrendingSection();
    bindFormSubmitListeners();
    loadFiltersInitially();
  });

  // Support Shopify Customizer Section reloading events
  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.sectionId && event.target.querySelector('.trending-products-container')) {
      bindModalControls();
      initTrendingSection();
      loadFiltersInitially();
    }
  });
})();
